import Link from 'next/link'
import React from 'react'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { ButtonLink } from '../components/ui/button'
import HedepyLogo from './HedepyLogo'

type Props = {
  backToIntroduction?: boolean
}

const SignUpHeader: React.FC<Props> = ({ backToIntroduction = false }) => {
  const { t } = getTranslate()
  const homepageUrl = '/'

  return (
    <div className="signup__header">
      <Link href={homepageUrl}>
        <HedepyLogo className="min-w-[140px] tablet:min-w-[200px]" />
      </Link>
      {backToIntroduction && (
        <ButtonLink href={homepageUrl} size="small" variant="light">
          {t('component.button.backToIntroduction')}
        </ButtonLink>
      )}
    </div>
  )
}

export default SignUpHeader
